var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCentroSalud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62.9 65",
    style: {
      enableBackground: "new 0 0 62.9 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008B81;}\n\t.st1{fill:#00A99D;}\n\t.st2{fill:#F4FBFE;}\n\t.st3{fill:#E13332;}\n\t.st4{fill:#E4F4FD;}\n\t.st5{fill:#465867;}\n\t.st6{fill:#C9DFEB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_92",
    className: "st0",
    d: "M4.6,17.9h54c2.4,0,4.3,1.9,4.3,4.3l0,0v42.1H0.2V22.2C0.2,19.8,2.2,17.9,4.6,17.9 C4.6,17.9,4.6,17.9,4.6,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_93",
    className: "st1",
    d: "M16.4,1.6h30.3C49.1,1.6,51,3.6,51,6c0,0,0,0,0,0v58.3H12.1V6C12.1,3.6,14.1,1.6,16.4,1.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    className: "st2",
    cx: 31.7,
    cy: 17.6,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_94",
    className: "st3",
    d: "M35.4,14.6h-1.6V13c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2v1.6h-1.6c-1.2,0-2.2,1-2.2,2.2 c0,1.2,1,2.2,2.2,2.2h1.6v1.6c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2l0,0v-1.6h1.6c1.2,0,2.2-1,2.2-2.2S36.6,14.6,35.4,14.6 C35.4,14.6,35.4,14.6,35.4,14.6L35.4,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95",
    className: "st4",
    d: "M21.9,48.1h9.7v16.2h-9.7V48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_96",
    className: "st4",
    d: "M31.6,48.1h9.7v16.2h-9.7V48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_97",
    className: "st5",
    d: "M18.6,43.8h25.9c0.6,0,1.1,0.5,1.1,1.1v3.2H17.5v-3.2C17.5,44.3,18,43.8,18.6,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98",
    className: "st5",
    d: "M45.6,48.1v16.2h-4.3V48.1H45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    className: "st5",
    d: "M21.9,48.1v16.2h-4.3V48.1H21.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_283",
    transform: "translate(5.403 23.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100",
    className: "st4",
    d: "M45.6,1.6H51c0.6,0,1.1,0.5,1.1,1.1V7c0,0.6-0.5,1.1-1.1,1.1h-5.4V1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_101",
    className: "st4",
    d: "M45.6,14.6H51c0.6,0,1.1,0.5,1.1,1.1V20c0,0.6-0.5,1.1-1.1,1.1h-5.4V14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_102",
    className: "st4",
    d: "M45.6,27.6H51c0.6,0,1.1,0.5,1.1,1.1V33c0,0.6-0.5,1.1-1.1,1.1h-5.4V27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_103",
    className: "st4",
    d: "M6.7,8.1H1.3C0.7,8.1,0.2,7.6,0.2,7c0,0,0,0,0,0V2.7c0-0.6,0.5-1.1,1.1-1.1h5.4L6.7,8.1 L6.7,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104",
    className: "st4",
    d: "M6.7,21.1H1.3c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-4.3c0-0.6,0.5-1.1,1.1-1.1h5.4 L6.7,21.1L6.7,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_105",
    className: "st4",
    d: "M6.7,34.1H1.3c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0v-4.3c0-0.6,0.5-1.1,1.1-1.1h5.4 L6.7,34.1L6.7,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_113",
    className: "st4",
    d: "M16.3,7.3h3c1.9,0,3.5,1.6,3.5,3.5l0,0c0,1.9-1.6,3.5-3.5,3.5h-3 c-1.9,0-3.5-1.6-3.5-3.5l0,0C12.8,8.8,14.4,7.3,16.3,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_114",
    className: "st4",
    d: "M33.3,7.3h4c1.9,0,3.5,1.6,3.5,3.5l0,0c0,1.9-1.6,3.5-3.5,3.5h-4 c-1.9,0-3.5-1.6-3.5-3.5l0,0C29.8,8.8,31.4,7.3,33.3,7.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_106",
    className: "st6",
    d: "M30.5,48.1h2.2v16.2h-2.2V48.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_45",
    className: "st6",
    cx: 35.7,
    cy: 56.1,
    rx: 0.5,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_46",
    className: "st6",
    cx: 27.2,
    cy: 56.1,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCentroSalud);
export default __webpack_public_path__ + "static/media/icon-centro-salud.23bd8b3edb275bb98f7591f7e977eb2f.svg";
export { ForwardRef as ReactComponent };